import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'G10-pages-layout',
  templateUrl: './pages-layout.component.html',
  styleUrls: ['./pages-layout.component.css']
})
export class PagesLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
